var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play_video"},[_c('div',{staticClass:"content"},[_c('video-player',{ref:"videoPlayer",staticClass:"custom-video-player vjs-custom-skin",attrs:{"playsinline":true,"options":_vm.playerOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }